import LogoTagline from "./logo_tagline.png";
import LogoTitleRight from "./logo_tagline.png";
import Logo from "./logo.png";
import LogoImageDefault from "./logo_image_default.jpeg";

export { LogoTagline, LogoTitleRight, Logo, LogoImageDefault };
